import * as React from 'react';
import {
    Datagrid,
    List,
    TextField,
    NumberField,
    DateField,
    SimpleList,
} from 'react-admin';
import { Box, makeStyles, Theme, useMediaQuery } from '@material-ui/core';
import { dateLocales, defaultDateOptions, percentFormatter } from '../utils/formatters';


const useStyles = makeStyles(theme => ({
    root: {
        // width: '50%',
        maxWidth: '800px',
        // margin: '0 auto',
    },
    name: { fontWeight: 'bold' },
}))
const PlatformList = (props: any) => {
    const classes = useStyles()

    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('xs')
    );

    return <MyList
        className={classes.root}
        {...props}>
        {isXSmall ? // Change of responsive design
            <SimpleList
                primaryText={record => `${record.name}`}
                secondaryText={record => `${record.description}`}
                tertiaryText={record => `VAT: ${record.data.VAT.value * 100}%`}
            // linkType={record => record.canEdit ? "edit" : "show"}
            // leftIcon={record => <financings.icon />}
            // rowStyle={postRowStyle}
            /> :
            <Datagrid
                size="medium"
                optimized
            >
                <NumberField source="id" />
                {!isXSmall && <DateField source="created_at" locales={dateLocales} options={defaultDateOptions} label="resources.common.fields.created_at" />}
                {!isXSmall && <DateField source="updated_at" locales={dateLocales} options={defaultDateOptions} label="resources.common.fields.updated_at" />} {/*/ showTime */}
                <TextField source="name" className={classes.name} />
                <TextField source="description" />
                <NumberField
                    source="data.VAT.value"
                    locales="en-US"
                    options={percentFormatter().resolvedOptions()}
                />
                <TextField source="data.country" emptyText="-" />
            </Datagrid>
        }
    </MyList>
};

const MyList = (props: any) => (
    <List
        {...props}
        component={Box}
        pagination={null}
        bulkActionButtons={false}
        exporter={false}
        actions={false}
    >
        {props.children}
    </List>
);

export default PlatformList;